<template>
  <div class="site-main-content" ref="siteMainContent">
    <!-- 站点的设备分类 -->
    <ul class="site-device-category" v-if="siteModelInfo && AUTH_SITE_DETAIL_MODEL_CATEGORY">
      <li v-for="model in siteModelInfo" :key="model.type">
        <router-link
          :to="{
            name: 'DeviceList',
            query: {
              customerId: siteData.customerInfo.customerId,
              devModelId: model.devModelId,
              siteId: stationId,
            },
          }"
          v-if="AUTH_DEVICE && model.value > 0"
        >
          <Icon :type="model.icon" />
          <div class="site-device-category-num">
            <strong>{{ model.value }}</strong>
            <span>{{ model.name }}</span>
          </div>
        </router-link>
        <div v-else>
          <Icon :type="model.icon" />
          <div class="site-device-category-num" style="background-image: none;">
            <strong style="color:rgba(0, 0, 0, 0.25);">{{ model.value }}</strong>
            <span>{{ model.name }}</span>
          </div>
        </div>
      </li>
    </ul>

    <!-- 站点状态和信息 -->
    <div class="site-status-info">
      <div class="site-status-info-left">
        <!-- 添加设备 -->
        <div class="site-status-info-title">
          <span>{{ $t('site_device_status') }}</span>
          <router-link
            :to="{
              name: 'DeviceAdd',
              query: { siteId: stationId },
            }"
            v-if="AUTH_DEVICE_ADD"
          >
            <a-button type="primary" icon="plus">
              {{ $t('com_btn_add_device') }}
            </a-button>
          </router-link>
        </div>

        <div class="site-status-info-wrapper">
          <ul class="site-status-info-left-num">
            <!-- 设备数量 -->
            <li>
              <strong>
                <router-link
                  :to="{
                    name: 'DeviceList',
                    query: {
                      type: 'all',
                      siteId: stationId,
                      customerId: siteData.customerInfo.customerId,
                    },
                  }"
                  v-if="siteData.customerInfo && siteData.deviceCount > 0 && AUTH_DEVICE"
                  style="color:#1838D9"
                >
                  {{ siteData.deviceCount }}
                </router-link>
                <em v-else style="color:#1838D9">
                  {{ siteData.deviceCount }}
                </em>
              </strong>
              <span>{{ $t('site_device_total') }}</span>
            </li>
            <!-- 离线设备数量 -->
            <li>
              <strong>
                <router-link
                  :to="{
                    name: 'DeviceList',
                    query: {
                      type: 'offline',
                      siteId: stationId,
                      customerId: siteData.customerInfo.customerId,
                    },
                  }"
                  v-if="siteData.customerInfo && siteData.deviceOfflineCount > 0 && AUTH_DEVICE"
                  style="color:#ddd"
                >
                  {{ siteData.deviceOfflineCount }}
                </router-link>
                <em v-else style="color:#ddd">
                  {{ siteData.deviceOfflineCount }}
                </em>
              </strong>
              <span>{{ $t('site_device_offline') }}</span>
            </li>
            <!-- 故障设备数量 -->
            <li>
              <strong>
                <router-link
                  :to="{
                    name: 'DeviceList',
                    query: {
                      type: 'faulted',
                      siteId: stationId,
                      customerId: siteData.customerInfo.customerId,
                    },
                  }"
                  v-if="siteData.customerInfo && siteData.deviceFaultedCount > 0 && AUTH_DEVICE"
                  style="color:#F53F3F"
                >
                  {{ siteData.deviceFaultedCount }}
                </router-link>
                <em v-else style="color:#F53F3F">
                  {{ siteData.deviceFaultedCount }}
                </em>
              </strong>
              <span>{{ $t('device_status_faulted') }}</span>
              <p v-if="siteData.deviceFaultedCount > 0">
                <i class="ca" v-if="alarmStatus.cas">CA {{ alarmStatus?.cas }}</i>
                <i class="ma" v-if="alarmStatus.mas">MA {{ alarmStatus?.mas }}</i>
                <i class="oa" v-if="alarmStatus.oas">OA {{ alarmStatus?.oas }}</i>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="site-status-info-right">
        <div class="site-status-info-title">
          <span>{{ $t('site_info_title') }}</span>
        </div>
        <div class="site-status-info-wrapper">
          <!-- 站点图片 -->
          <div class="site-status-info-img">
            <ImageSlider :listData="siteData?.info?.icons" />
          </div>
          <ul class="site-status-info-item">
            <!-- 客户 -->
            <li v-if="siteData.customerInfo && siteData.customerInfo.name">
              <label>{{ $t('site_info_customer') }} :</label>
              <span>
                <router-link
                  :to="`/manage/system/customer/detail/${siteData.info.customerId}`"
                  v-if="AUTH_CUSTOMER_DETAIL"
                >
                  {{ siteData.customerInfo.name }}
                </router-link>
                <span v-else>
                  {{ siteData.customerInfo.name }}
                </span>
              </span>
            </li>

            <!-- 创建人 -->
            <li>
              <label> {{ $t('com_table_created_by') }} :</label>
              <span v-if="siteData.info">
                <router-link
                  :to="{
                    name: 'UserDetail',
                    params: { id: siteData?.info?.createBy },
                  }"
                  v-if="AUTH_USER_DETAIL"
                >
                  {{ siteData?.info?.createUser }}
                </router-link>
                <span v-else>
                  {{ siteData?.info?.createUser }}
                </span>

                <span style="padding-left:5px;">{{
                  siteData.ct.executeTime | formatDate('yyyy-MM-dd HH:mm:ss')
                }}</span>
              </span>
              <span v-else>--</span>
            </li>
            <!-- 地区/国家 -->
            <li v-if="siteData.info">
              <label>{{ $t('com_form_area_region_label') }} :</label>
              <p>
                <span v-if="siteData.info.areaId && areaListObject[siteData.info.areaId]">
                  {{ areaListObject[siteData.info.areaId]?.name }}
                  <span v-if="siteData.info.regionId && areaListObject[siteData.info.regionId]">
                    <i>></i> {{ areaListObject[siteData.info.regionId]?.name }}
                  </span>
                </span>
                <span v-else>--</span>
              </p>
            </li>
            <!-- 创建日期 -->
            <li v-if="siteData.info">
              <label>{{ $t('site_info_build_date') }} :</label>
              <span v-if="siteData.info.buildDate">
                {{ siteData.info.buildDate | formatDate('yyyy-MM-dd') }}
              </span>
              <span v-else>--</span>
            </li>
            <!-- 地址 -->
            <li v-if="siteData.info">
              <label>{{ $t('site_info_address') }} :</label>
              <a-popover arrow-point-at-center>
                <template #content>
                  <div class="popover-info">{{ siteData.info.instAddress }}</div>
                </template>
                <span>
                  {{ siteData.info.instAddress || '--' }}
                </span>
              </a-popover>
            </li>
            <!-- 描述 -->
            <li v-if="siteData.info && siteData.info.description">
              <label>{{ $t('com_form_description') }} :</label>
              <a-popover arrow-point-at-center>
                <template #content>
                  <div class="popover-info">{{ siteData.info.description }}</div>
                </template>
                <span>
                  {{ siteData.info.description || '--' }}
                </span>
              </a-popover>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 站点统计相关列表 -->
    <div class="site-detail-tabs" v-if="tabsList && tabsList.length > 0">
      <div class="site-detail-tabs-content">
        <div class="site-detail-tabs-nav">
          <ul>
            <li
              v-for="item in tabsList"
              :key="item.key"
              :class="activeTab === item.key ? 'active' : ''"
              @click="tabs(item.key)"
            >
              {{ item.name }}
            </li>
          </ul>
          <div class="site-detail-tabs-filter">
            <!-- 状态 -->
            <div v-show="activeTab === '1' && AUTH_SITE_DETAIL_STATUS_STATISTICS">
              <div class="site-detail-tabs-traffic">
                <a-select
                  v-model="failureTypeValue"
                  @change="handleFailureTypeChange"
                  :getPopupContainer="triggerNode => triggerNode.parentNode"
                >
                  <a-select-option :value="0">
                    {{ $t('com_form_all') }}
                  </a-select-option>
                  <a-select-option
                    :value="item.value"
                    v-for="item in failureTypeList"
                    :key="item.value"
                  >
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </div>

              <DateFilter
                @change="
                  dateData => {
                    this.siteStatusDate = dateData.date;
                    this.siteStatusInterval = dateData.time;
                    this.siteStatusDateModel = dateData.modeValue;
                    this.siteStatusXTimeFormatter = dateData.timeFormat;
                    // 重新获取数据
                    this.getStatusData();
                  }
                "
                ref="StatusDateFilter"
              />
              <a-button type="primary" @click="getStatusData"
                >{{ $t('com_btn_lookfor') }}
              </a-button>
              <a-button
                type="default"
                @click="
                  () => {
                    this.$refs.StatusDateFilter.reset();
                  }
                "
                >{{ $t('com_btn_reset') }}</a-button
              >
            </div>
            <!-- 流量 -->
            <div v-show="activeTab === '2' && AUTH_SITE_DETAIL_TRAFFIC_STATISTICS">
              <div class="site-detail-tabs-traffic">
                <a-select
                  v-model="trafficType"
                  @change="trafficTypeChange"
                  :getPopupContainer="triggerNode => triggerNode.parentNode"
                >
                  <a-select-option value="">
                    {{ $t('com_form_all') }}
                  </a-select-option>
                  <a-select-option
                    v-for="(item, index) in trafficTypeList"
                    :key="index"
                    :value="item.source"
                  >
                    {{ item.source }}
                  </a-select-option>
                </a-select>
              </div>

              <DateFilter
                @change="
                  dateData => {
                    this.trafficDate = dateData.date;
                    this.trafficInterval = dateData.time;
                    this.trafficDateModel = dateData.modeValue;
                    this.trafficXTimeFormatter = dateData.timeFormat;
                    // 重新流量统计
                    this.getSiteTrafficDevice();
                  }
                "
                :mode="[
                  {
                    value: 'month',
                    options: [60 * 24],
                  },
                  {
                    value: 'year',
                  },
                ]"
                ref="TrafficDateFilter"
              />
              <a-button
                type="primary"
                @click="
                  () => {
                    this.getSiteTrafficDevice();
                  }
                "
                >{{ $t('com_btn_lookfor') }}</a-button
              >
              <a-button
                type="default"
                @click="
                  () => {
                    trafficType = '';
                    $refs.TrafficDateFilter.reset();
                  }
                "
                >{{ $t('com_btn_reset') }}</a-button
              >
            </div>

            <!-- 累计 -->
            <div v-show="activeTab === '3' && AUTH_SITE_DETAIL_TRAFFIC_ACCUMULATION">
              <div class="site-detail-tabs-traffic">
                <a-select
                  v-model="trafficTotalType"
                  @change="trafficTotalTypeChange"
                  :getPopupContainer="triggerNode => triggerNode.parentNode"
                >
                  <a-select-option value="">
                    {{ $t('com_form_all') }}
                  </a-select-option>
                  <a-select-option
                    v-for="(item, index) in trafficTypeList"
                    :key="index"
                    :value="item.source"
                  >
                    {{ item.source }}
                  </a-select-option>
                </a-select>
              </div>
              <DateFilter
                @change="
                  dateData => {
                    this.trafficTotalDate = dateData.date;
                    this.trafficTotalInterval = dateData.time;
                    this.trafficTotalDateModel = dateData.modeValue;
                    this.trafficTotalXTimeFormatter = dateData.timeFormat;
                    // 获取累计流量
                    this.getSiteTrafficTotalDevice();
                  }
                "
                :mode="[{ value: 'month', options: [60 * 24] }, { value: 'year' }]"
                ref="CumulativeTraffic"
              />
              <a-button
                type="primary"
                @click="
                  () => {
                    this.getSiteTrafficTotalDevice();
                  }
                "
                >{{ $t('com_btn_lookfor') }}</a-button
              >
              <a-button
                type="default"
                @click="
                  () => {
                    this.trafficTotalType = '';
                    this.$refs.CumulativeTraffic.reset();
                  }
                "
                >{{ $t('com_btn_reset') }}</a-button
              >
            </div>

            <!-- 管理员 -->
            <div v-show="activeTab === '4' && AUTH_SITE_ADMIN_LIST">
              <a-input
                :placeholder="$t('site_form_user_placeholder')"
                style="width: 300px;"
                v-model="userKeyword"
              />
              <a-button type="primary" @click="getStationUsers">{{
                $t('com_btn_lookfor')
              }}</a-button>
              <a-button
                type="default"
                @click="
                  () => {
                    this.userKeyword = '';
                    this.getStationUsers();
                  }
                "
                >{{ $t('com_btn_reset') }}</a-button
              >
            </div>
          </div>
        </div>
        <div class="site-detail-tabs-wrapper">
          <!-- 状态统计 -->
          <div
            class="site-detail-tabs-content"
            v-if="activeTab === '1' && AUTH_SITE_DETAIL_STATUS_STATISTICS"
          >
            <ColumnarChart
              :dataSource="siteStatusChartData"
              legendField="faultName"
              xField="startDate"
              :xLabelFormatter="
                value => {
                  return moment(value).format(siteStatusXTimeFormatter);
                }
              "
              v-if="siteStatusChartData && siteStatusChartData.length > 0"
            />
            <Empty style="padding:100px 0" v-else />
          </div>

          <!-- 流量统计 -->
          <div
            class="site-detail-tabs-content"
            v-if="activeTab === '2' && AUTH_SITE_DETAIL_TRAFFIC_STATISTICS"
          >
            <LineChart
              :dataSource="trafficData"
              xField="startDate"
              yField="value"
              :xLabelFormatter="
                value => {
                  return moment(value).format(trafficXTimeFormatter);
                }
              "
              v-if="trafficData && trafficData.length > 0"
              :height="700"
              :formatValue="filters.formatTraffficSize"
            />
            <Empty style="padding:100px 0" v-else />
          </div>

          <!-- 累计统计 -->
          <div
            class="site-detail-tabs-content"
            v-if="activeTab === '3' && AUTH_SITE_DETAIL_TRAFFIC_ACCUMULATION"
          >
            <LineChart
              :dataSource="trafficTotalData"
              xField="startDate"
              yField="value"
              :xLabelFormatter="
                value => {
                  return moment(value).format(trafficTotalXTimeFormatter);
                }
              "
              :height="700"
              :formatValue="filters.formatTraffficSize"
              v-if="trafficTotalData && trafficTotalData.length > 0"
            />
            <Empty style="padding:100px 0" v-else />
          </div>

          <!-- 管理员列表(超级管理员、及infypower root才能看) -->
          <div class="site-detail-tabs-content" v-if="activeTab === '4' && AUTH_SITE_ADMIN_LIST">
            <div class="site-detail-tabs-table">
              <a-table
                :columns="columns"
                :data-source="userListData"
                bordered
                rowKey="userId"
                :pagination="false"
                :loading="userTableLoading"
              >
                <!-- name -->
                <template slot="name" slot-scope="text, record">
                  <!-- 没有用户管理权限时不可以跳转 -->
                  <router-link
                    :to="{ name: 'UserDetail', params: { id: record.userId } }"
                    v-if="AUTH_USER_DETAIL"
                  >
                    {{ text }}
                  </router-link>
                  <span v-else>{{ text }}</span>
                </template>

                <!-- 是否为告警对象 -->
                <template slot="receiveAlarm" slot-scope="text, record">
                  <span v-if="text === true">{{ $t('com_table_yes') }}</span>
                  <span v-else>{{ $t('com_table_no') }}</span>
                </template>
              </a-table>
              <div class="site-userPagination">
                <Pagination
                  :current.sync="userPagination.current"
                  :total="userPagination.total"
                  :pageSize.sync="userPagination.pageSize"
                  :callback="userPageChange"
                  @change="userPageChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Config from '@/config';
import areaMixin from '@/mixins/area';
import DateFilter from '@/components/DateFilter';
import LineChart from '_c/charts/Line';
import * as API from '@/api/site';
import {
  splitTimeRangeWithData,
  mergeDataInSameDate,
  sortFaultData,
  accumulate,
} from '@/libs/utils';
import ColumnarChart from '_c/charts/Columnar';
import moment from 'moment';
import siteAuth from '@/views/site/mixins/siteAuth';
import deviceAuth from '@/views/device/mixins/deviceAuth';

export default {
  components: {
    DateFilter,
    LineChart,
    ColumnarChart,
  },
  mixins: [areaMixin, siteAuth, deviceAuth],
  props: {
    // 站点信息
    siteData: {
      type: Object,
      default: () => ({}),
    },
    // 站点Id
    stationId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      filters: this.$options.filters,
      console: window.console,
      moment,
      // 故障类型，默认为故障(Unavailable)；1-离线(offline)，2-告警(Alarm)，3-故障(Unavailable)。不填时则默认值为3
      failureTypeValue: 0,
      failureTypeList: [
        {
          value: 1,
          label: this.$t('com_fault_type_offline'),
        },
        {
          value: 2,
          label: this.$t('com_fault_type_alarm'),
        },
        {
          value: 3,
          label: this.$t('com_fault_type_unavailable'),
        },
      ],

      // 站点模型信息
      siteModelInfo: [
        {
          type: 1,
          icon: 'device_charging_pile',
          name: this.$t('site_device_category_charging'),
          value: 0,
        },
        {
          type: 2,
          icon: 'device_ac_pile',
          name: this.$t('site_device_category_charging_ac'),
          value: 0,
        },
        {
          type: 3,
          icon: 'device_energy_pile',
          name: this.$t('site_device_category_charging_energy'),
          value: 0,
        },
        {
          type: 4,
          icon: 'device_power',
          name: this.$t('site_device_category_energy'),
          value: 0,
        },
        {
          type: 5,
          icon: 'device_home_energy',
          name: this.$t('site_device_category_energy_home'),
          value: 0,
        },
        {
          type: 6,
          icon: 'device_v2g',
          name: this.$t('site_device_category_v2g'),
          value: 0,
        },
      ],

      chartData: [],
      Config,
      tabsList: [],
      activeTab: '1',

      // table columns
      columns: [
        {
          title: this.$t('com_table_index'),
          align: 'center',
          width: 100,
          customRender: (text, record, index) => {
            return (this.userPagination.current - 1) * this.userPagination.pageSize + (index + 1);
          },
        },
        {
          title: this.$t('site_table_admin_name'),
          align: 'center',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },

        {
          title: this.$t('site_table_admin_role'),
          align: 'center',
          dataIndex: 'roleName',
        },
        {
          title: this.$t('site_table_admin_alarm'),
          align: 'center',
          dataIndex: 'receiveAlarm',
          scopedSlots: { customRender: 'receiveAlarm' },
        },
        {
          title: this.$t('site_table_admin_addtime'),
          align: 'center',
          dataIndex: 'createTime',
          customRender: text => {
            return this.filters.formatDate(text);
          },
        },
      ],

      // ------------------- 站点状态
      // 站点状态统计数据
      siteStatusChartData: null,
      // 站点状态统计时间
      siteStatusDate: null,
      // 站点状态间隔时间
      siteStatusInterval: null,
      // 站点状态时间模式
      siteStatusDateModel: null,
      // 站点状态X轴格式化
      siteStatusXTimeFormatter: '',

      // ------------------- 流量统计
      // 流量类型
      trafficType: '',
      // 流量类型列表
      trafficTypeList: null,
      // 数量数据
      trafficData: null,
      // 站点状态统计时间
      trafficDate: null,
      // 站点状态间隔时间
      trafficInterval: null,
      // 站点状态时间模式
      trafficDateModel: null,
      // 站点状态X轴格式化
      trafficXTimeFormatter: '',

      // ------------------- 累计流量
      // 流量类型
      trafficTotalType: '',
      // 数量数据
      trafficTotalData: null,
      // 站点状态统计时间
      trafficTotalDate: null,
      // 站点状态间隔时间
      trafficTotalInterval: null,
      // 站点状态时间模式
      trafficTotalDateModel: null,
      // 站点状态X轴格式化
      trafficTotalXTimeFormatter: '',

      // ------------------- 管理员列表
      // 管理员列表数据
      userListData: null,
      userTableLoading: false,
      userKeyword: '',
      // 分页
      userPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 10,
        // 记录总条数
        total: 0,
      },

      // 告警状态
      alarmStatus: {},
    };
  },
  created() {
    // tab - 状态统计
    if (this.AUTH_SITE_DETAIL_STATUS_STATISTICS) {
      this.tabsList.push({
        name: this.$t('site_tab_status_statistics'),
        key: '1',
      });
    }

    // tab - 流量统计
    if (this.AUTH_SITE_DETAIL_TRAFFIC_STATISTICS) {
      this.tabsList.push({
        name: this.$t('site_tab_traffic_statistics'),
        key: '2',
      });
    }

    // tab - 累计统计
    if (this.AUTH_SITE_DETAIL_TRAFFIC_ACCUMULATION) {
      this.tabsList.push({
        name: this.$t('site_tab_cumulative_statistics'),
        key: '3',
      });
    }

    // tab - 管理员列表（超级管理员、及infypower root才能看）
    if (this.AUTH_SITE_ADMIN_LIST) {
      this.tabsList.push({
        name: this.$t('site_tab_admin_list'),
        key: '4',
      });
    }

    // 默认第一个
    if (this.tabsList.length > 0) {
      this.activeTab = this.tabsList[0].key;
    }
    // 获取默认数据
    this.tabs(this.activeTab);

    // 获取站点模型
    if (this.AUTH_SITE_DETAIL_MODEL_CATEGORY) {
      this.getSiteModel();
    }

    // 预先加载下拉选项
    this.getSiteTrafficType();
    this.getStationStatus();
  },

  methods: {
    // 流量类型handler
    trafficTypeChange(value) {
      this.trafficType = value;
      this.getSiteTrafficDevice();
    },

    // 累计流量类型handler
    trafficTotalTypeChange(value) {
      this.trafficTotalType = value;
      this.getSiteTrafficTotalDevice();
    },

    // 获取流量类型
    getSiteTrafficType() {
      API.SiteTrafficPlatform({
        stationId: this.stationId,
      }).then(res => {
        if (res.code === 0) {
          // console.log('res.data', res.data);
          this.trafficTypeList = res.data;
          // 默认第一个（正常默认所有）
          // this.trafficType = res.data[0].source;
        }
      });
    },

    // 获取流量列表
    getSiteTrafficDevice() {
      // 时间区间
      let startDate = '';
      let endDate = '';
      if (!this.trafficDate) {
        return;
      }

      if (this.trafficDate.length === 2) {
        startDate = this.trafficDate[0].format('YYYY/MM/DD 00:00:00');
        endDate = this.trafficDate[1].format('YYYY/MM/DD 23:59:59');
      } else {
        startDate = this.trafficDate.format('YYYY/MM/DD 00:00:00');
        endDate = this.trafficDate.format('YYYY/MM/DD 23:59:59');
      }
      API.SiteTrafficDevice({
        platform: this.trafficType,
        stationId: this.stationId,
        startTime: new Date(startDate).getTime(),
        endTime: new Date(endDate).getTime(),
      }).then(res => {
        if (res.code === 0) {
          const _data = res.data || [];
          // 根据选择的日期区间，合并数据
          this.trafficData = mergeDataInSameDate(
            startDate,
            endDate,
            this.trafficInterval,
            _data,
            'trafficTime',
            'networkTraffic'
          );
        }
      });
    },

    // 获取累计流量列表
    getSiteTrafficTotalDevice() {
      // 时间区间
      let startDate = '';
      let endDate = '';
      if (!this.trafficTotalDate) {
        return;
      }

      // 日期有值后才请求数据
      if (this.trafficTotalDate.length === 2) {
        startDate = this.trafficTotalDate[0].format('YYYY/MM/DD 00:00:00');
        endDate = this.trafficTotalDate[1].format('YYYY/MM/DD 23:59:59');
      } else {
        startDate = this.trafficTotalDate.format('YYYY/MM/DD 00:00:00');
        endDate = this.trafficTotalDate.format('YYYY/MM/DD 23:59:59');
      }
      API.SiteTrafficTotal({
        platform: this.trafficTotalType,
        stationId: this.stationId,
        startTime: new Date(startDate).getTime(),
        endTime: new Date(endDate).getTime(),
      }).then(res => {
        if (res.code === 0) {
          const _data = res.data || [];

          // 根据选择的日期区间，合并数据
          const _data2 = mergeDataInSameDate(
            startDate,
            endDate,
            this.trafficTotalInterval,
            _data,
            'trafficTime',
            'networkTraffic'
          );

          // 对数据进行累加
          this.trafficTotalData = accumulate(_data2, 'value');
        }
      });
    },

    // get site model
    getSiteModel() {
      API.SiteAllModelList({
        stationId: this.stationId,
      }).then(res => {
        if (res.code === 0) {
          const _data = res.data;
          if (_data) {
            _data.forEach(item => {
              const _index = this.siteModelInfo.findIndex(model => model.type === item.avatar);
              if (_index > -1) {
                this.$set(this.siteModelInfo, _index, {
                  ...this.siteModelInfo[_index],
                  value: item.count,
                  devModelId: item.devModelId,
                });
              }
            });

            this.siteModelInfo = this.siteModelInfo.sort((a, b) => b.value - a.value);
          }
        }
      });
    },

    // 获取状态统计数据
    getStatusData() {
      // 时间区间
      let startDate = '';
      let endDate = '';
      if (this.siteStatusDate && this.siteStatusDate.length === 2) {
        startDate = this.siteStatusDate[0].format('YYYY/MM/DD 00:00:00');
        endDate = this.siteStatusDate[1].format('YYYY/MM/DD 23:59:59');
      } else {
        startDate = this.siteStatusDate.format('YYYY/MM/DD 00:00:00');
        endDate = this.siteStatusDate.format('YYYY/MM/DD 23:59:59');
      }

      API.SiteStatus({
        stationId: this.stationId,
        startTime: new Date(startDate).getTime(),
        endTime: new Date(endDate).getTime(),
        type: this.failureTypeValue || 0,
      }).then(res => {
        if (res.code === 0) {
          // console.log('res', res);
          let _data = res?.data || [];
          // 处理数据，添加一个报错名称的字段
          // faultDynamicStatus:"故障类型，1-离线(offline)，2-告警(Alarm)，3-故障(Unavailable)",

          _data = splitTimeRangeWithData(
            startDate,
            endDate,
            // 选中的时间间隔
            this.siteStatusInterval,
            res.data,
            'startDate',
            'faultDynamicStatus'
          );
          _data.forEach(record => {
            // 错误类型
            record.faultName = record.faultDynamicStatus;
          });

          // 根据故障类型排序
          _data = sortFaultData(_data, 'faultDynamicStatus');

          this.siteStatusChartData = _data;
        }
      });
    },

    // get user list
    getStationUsers() {
      this.userTableLoading = true;
      API.SiteUsers({
        stationId: this.stationId,
        keyword: this.userKeyword,
        pageNo: this.userPagination.current,
        pageSize: this.userPagination.pageSize,
      })
        .then(res => {
          if (res.code === 0) {
            this.userListData = res.data;
            this.userPagination.total = res.totalCount;
          }
        })
        .finally(() => {
          this.userTableLoading = false;
        });
    },

    // user list pagination
    userPageChange(page) {
      this.userPagination.current = page;
      this.getStationUsers();
    },

    tabs(tab) {
      if (this.activeTab === tab) return;
      this.activeTab = tab;

      // 获取流量
      if (tab === '2') {
        this.getSiteTrafficDevice();
      }

      // 获取累计流量
      if (tab === '3') {
        this.getSiteTrafficTotalDevice();
      }

      // 获取管理员列表
      if (tab === '4') {
        this.getStationUsers();
      }
    },

    // 动态获取alarm数据
    getStationStatus() {
      if (!this.stationId) {
        return;
      }

      return API.SiteQueryStatus({ stationIds: this.stationId }).then(res => {
        if (res.code === 0) {
          this.alarmStatus = {};
          res.data.forEach(item => {
            if (item.stationId === this.stationId) this.alarmStatus = item;
          });

          console.log('alarmStatus', this.alarmStatus);
        }
      });
    },

    handleFailureTypeChange(value) {
      this.failureTypeValue = value;
      this.getStatusData();
    },
  },
};
</script>
<style lang="less">
.ant-popover-inner-content {
  .popover-info {
    width: 360px;
    word-break: break-all;
    max-height: 300px;
    overflow-y: auto;
  }
}
</style>
<style lang="less" scoped>
.site-main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #fff;
  // device category
  .site-device-category {
    display: flex;
    margin: 0;
    padding: 0 0 16px 0;
    gap: 16px;
    background: @g-layout-background;

    li {
      width: 16.6666%;
      background: none;
      > div,
      > a {
        height: 104px;
        background: #fff; /* 作为渐变的降级方案 */
        background: -webkit-linear-gradient(180deg, #fff 0%, #f9f9fd 100%); /* 旧版 Safari、iOS */
        background: -moz-linear-gradient(180deg, #fff 0%, #f9f9fd 100%); /* 旧版 Firefox */
        background: -o-linear-gradient(180deg, #fff 0%, #f9f9fd 100%); /* 旧版 Opera */
        background: -ms-linear-gradient(180deg, #fff 0%, #f9f9fd 100%); /* 旧版 IE */
        background: linear-gradient(180deg, #fff 0%, #f9f9fd 100%); /* 标准语法 */
        display: flex;
        align-items: center;
        justify-content: flex-start;
        overflow: hidden;
        border-radius: 12px;
        border: 1px solid #fff;
        svg.icon {
          height: 56px;
          width: 56px;
          margin-left: 24px;
          margin-right: 12px;
        }
        .site-device-category-num {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          background: url('~@/assets/img/arrow_right.png') right 12px center no-repeat;
          background-size: 18px auto;
          strong {
            color: #000;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
          }
          span {
            color: #45454a;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
          }
        }
      }
    }
  }

  // site status and info
  .site-status-info {
    display: flex;
    padding: 0;
    gap: 16px;
    height: 280px;
    padding-bottom: 16px;
    background: @g-layout-background;
    width: 100%;

    .site-status-info-title {
      color: #18181a;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
    }

    .site-status-info-wrapper {
      height: calc(100% - 40px);
      display: flex;
      align-items: center;

      ::v-deep .site-status-info-img {
        height: 100%;
        .g-img-error {
          height: 180px;
        }
        .g-images-slider {
          display: flex;
          height: auto;
          align-items: flex-start;
        }
      }
    }

    .site-status-info-left {
      flex: 0 0 40%;
      border-radius: 12px;
      padding: 15px 24px 24px 24px;
      background: #fff url('~@/assets/img/bg.png') right center no-repeat;
      background-size: 100% 100%;

      .site-status-info-left-num {
        margin: 0;
        padding: 0;
        display: flex;
        height: 84px;
        flex: 1;
        li {
          flex: 1;
          background: url('~@/assets/img/line_bg.png') right center no-repeat;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;

          strong {
            text-align: center;
            font-size: 36px;
            font-weight: 700;
          }

          span {
            color: rgba(0, 0, 0, 0.45);
            font-size: 16px;
            font-weight: 400;
            margin-bottom: 5px;
          }

          em {
            font-style: normal;
          }

          p {
            padding: 0;
            white-space: nowrap;
            margin: 10px 0 0 0;
            display: flex;
            i {
              border-radius: 4px;
              border: 1px solid #ffccc7;
              background: #fff1f0;
              margin: 0 4px;
              font-style: normal;
              padding: 0 4px;
              font-size: 14px;

              &.ca {
                border: 1px solid #ffccc7;
                background: #fff1f0;
              }

              &.ma {
                border: 1px solid #fff1b8;
                background: #fffbe6;
              }

              &.oa {
                border: 1px solid #b5f5ec;
                background: #e6fffb;
              }
            }
          }

          &:last-child {
            background: none;
          }
        }
      }
    }
  }

  // 站点简介
  .site-status-info-right {
    flex: 0 0 calc(60% - 12px);
    background: #fff;
    border-radius: 12px;
    padding: 10px 24px 24px 24px;
    height: 100%;
    width: calc(60% - 12px);
    // 图片
    .site-status-info-img {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      width: 280px;

      .site-status-info-space {
        width: 100%;
        min-height: 150px;
      }

      img {
        max-width: 100%;
        border-radius: 12px;
        height: 100%;
        width: 100%;
      }
    }

    // 简要描述
    .site-status-info-item {
      flex: 1;
      height: 100%;
      padding-left: 24px;
      margin: 0;
      width: calc(100% - 280px);

      li {
        padding-bottom: 12px;
        font-size: 14px;
        display: flex;
        width: 100%;
        gap: 5px;
        label {
          white-space: nowrap;
        }
        span {
          // word-break: break-all; // 溢出折换行
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        p {
          margin: 0;
          padding: 0;

          i {
            font-style: normal;
            padding: 0 5px;
          }
        }

        &:last-child {
          padding-bottom: 0;
        }

        a {
          cursor: pointer;
        }
      }
    }
  }

  // site detail tabs
  .site-detail-tabs {
    border-radius: 12px;
    background: #fff;
    padding: 0 24px;
    // min-height: calc(100% - 106px - 280px); // 507px
    // min-height: 507px;
    height: auto;
    flex-direction: column;
    box-shadow: 0 -12px 0 0 @g-layout-background; /* 模拟红色边框 */

    // tabs nav
    .site-detail-tabs-nav {
      display: flex;
      overflow: hidden;
      justify-content: space-between;
      font-size: 14px;
      padding: 24px 12px 6px;
      flex-wrap: wrap;

      ul {
        display: flex;
        align-items: center;
        gap: 24px;
        li {
          display: flex;
          height: 40px;
          padding: 16px 0px;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          color: rgba(0, 0, 0, 0.88);
          font-size: 16px;
          font-weight: 400;

          &.active {
            color: #1838d9;
            font-size: 16px;
            font-weight: 600;
            position: relative;
            cursor: pointer;

            &::after {
              content: ' ';
              display: block;
              width: 100%;
              height: 2px;
              background: #1838d9;
              position: absolute;
              bottom: 0;
            }
          }
        }
      }

      .site-detail-tabs-filter {
        display: flex;
        > div {
          display: flex;
          flex: 1;

          .site-detail-tabs-traffic {
            margin-right: 10px;
          }
        }

        button {
          margin-left: 12px;
        }
      }
    }

    // tabs content
    ::v-deep .site-detail-tabs-wrapper {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;
      width: 100%;
      position: relative;
      padding-bottom: 24px;

      .page-loading {
        position: absolute;
        left: 48%;
        top: 40%;
        margin: 0 auto;
        z-index: 0;
      }

      .site-detail-tabs-content {
        width: 100%;
        min-height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 1;
        background: #fff;
        flex: 1;

        .site-detail-tabs-table {
          width: 100%;
          min-height: 100%;
        }
      }
    }
  }
}
</style>
